<script>
  let {
    Menu = [
      {
        icon:"",
        iconPath:"",
        href:"",
        sendSPID:"",
        label:"",
        caption:"",
        childMenu: [
          {
            href:"",
            sendSPID:"",
            label:"",
            caption:"",
          }
        ]
      }
    ]
  } = $props();



</script>

<nav class="menu-nav">
  <ul class="menu-nav-lists">
    {#each Menu as menu, index}
      <li class="menu-nav-list" style={menu.href && !menu.childMenu?.length ? "height:76px" : "min-height:75px;height:auto"}>
        {#if menu.href && !menu.childMenu?.length}
          <a
            href={menu.href}
            target={menu.blank ? "_blank" : undefined}
            class="menu-item-link"
            id={menu.sendSPID ? menu.sendSPID : undefined}
            >
            <div class="menu-item-link-block">
              <span class="menu-label-iconlabel">
                <span class="menu-label-icon"><img src={menu.iconPath} alt="icon" width="24" height="24"></span>
                <span class="owd-text:01"><strong>{menu.label}</strong></span>
              </span>
              {#if menu.caption}
                <span class="menu-caption owd-text:03">{menu.caption}</span>
              {/if}
            </div>
            <div class="menu-item-link-arrow">
              <img src="/assets_default/icons/chevron_right.svg" alt="">
            </div>
          </a>
        {:else}
          <details class="accordion-item">
            <summary class="accordion-item-label" >
              <div class="accordion-item-label-block">
                <div class={menu.caption ? "accordion-item-iconlabel spacing:bottom:12" : "accordion-item-iconlabel"}>
                  <span class="accordion-item-label-icon"><img src={menu.iconPath} alt="icon" width="24" height="24"></span>

                  <span class="owd-text:01"><strong>{menu.label}</strong></span>
                </div>
                {#if menu.caption}
                  <span class="accordion-item-label-caption owd-text:03">{menu.caption}</span>
                {/if}
              </div>

              <span class="accordion-item-chevron">
                <img src="/assets_default/icons/chevron_down.svg" alt="">
              </span>
            </summary>
            {#if menu.childMenu && menu.childMenu.length > 0}
              <ul class="child-menu-list">
                {#each menu.childMenu as child}
                  <li>
                    <a
                      href={child.href}
                      id={child.sendSPID ? child.sendSId : undefined}
                      class="child-menu-link">
                      <div class="child-menu-link-block">
                        <span class="child-label spacing:bottom:12 owd-text:02">
                          <span class="child-label-icon"></span>
                          <strong>{child.label}</strong></span>
                        {#if child.caption}
                          <span class="child-caption owd-text:03">{@html child.caption}</span>
                        {/if}
                      </div>
                      <span class="child-menu-link-chevron">
                        <img src="/assets_default/icons/chevron_right.svg" alt="" />
                      </span>
                    </a>
                  </li>
                {/each}
              </ul>
            {/if}
          </details>
        {/if}
      </li>
    {/each}
  </ul>
</nav>

<style lang="scss">



  .accordion-item {
    &[open] {
      .accordion-item-chevron {
        transform: rotate(180deg);
      }

    }
    &-label {
      display: grid;
      grid-template-columns: auto 24px;
      align-items: center;
      padding: 16px 24px;
      border-bottom: 1px solid var(--black-opacity1);

      &-block {
        list-style: none;
      }
      &-icon {
        width: 24px;
        height: 24px;
        display: inline-block;
      }
    }
    &-iconlabel {
      display: grid;
      align-items: center;
      grid-template-columns: 24px 1fr;
      gap: 8px;
      font-weight: 600;
    }
  }

  .child-label {
    display: block;
  }

  .child-menu-list {
    >li{
      border-top: 2px solid var(--black-opacity1);
    }

    .child-menu-link {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 24px;
      background: var(--light-gray);
      padding: 24px 24px 24px 40px;
      text-decoration: none;
      border-bottom: 1px solid var(--black-opacity1)

      &-block {
        display: flex;
        flex-direction: column;
      }

      &-chevron {
        img {
          width: 100%;
        }
      }
    }

  }



  .menu-item {
    &-link {
      padding: 16px 24px;
      text-decoration: none;
      border-bottom: 1px solid var(--black-opacity1);
      display: grid;
      gap: 8px;
      grid-template-columns: 1fr 24px;
      align-items: center;
      height: 100%;
      &-arrow {
        width: 24px;
        height: 24px;
        img {
          width: 100%;
        }
      }
    }
  }

  .menu-caption {
    display: block;
    margin-top: 8px;
  }

  .menu-label-iconlabel {
    align-items: center;
    display: grid;
    grid-template-columns: 24px 1fr;
    gap: 8px;
    font-weight: 600;

    .menu-label {

      &-icon {
        @include g.owd-typography("text-1");
        font-weight: 600;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

    }
  }

  .menu-nav-list {
    border-bottom: 1px solid var(--black-opacity1);
  }
</style>
